import useGlobalMutation from "../../../hooks/useGlobalMutation";
import { UPDATE_STATUS } from "./query";
import { updateCache } from "../../../utils";
import { Loader } from "../../shared";

const ProfileActivation = ({ id, userStatus }) => {
    const { submitMutation, loading } = useGlobalMutation(UPDATE_STATUS, (cache, result) => {
        const basicLoginUser = result?.data?.updateBasicLoginUserStatus?.basicLoginUser;
        updateCache(cache, id, basicLoginUser, "BasicLoginUser");
    });

    const handleProfileActivation = async (status) => {
        const variables = {
            id,
            userStatus: status,
        };
        await submitMutation(
            variables,
            "updateBasicLoginUserStatus.basicLoginUser",
            `Profile ${status === 1 ? "Activated" : "Deactivated"} Successfully`
        );
    };

    return (
        <>
            {loading && <Loader />}

            <div className="row justify-content-center">
                <div className="col-auto d-flex flex-column justify-content-center p-3">
                    <h5 className="mb-3">
                        Current Status:{" "}
                        <span className={userStatus === 1 ? "text-success" : "text-danger"}>
                            {userStatus === 1 ? "Active" : "Inactive"}
                        </span>
                    </h5>
                    <button
                        onClick={() => handleProfileActivation(userStatus === 1 ? 0 : 1)}
                        className={`btn btn-${
                            userStatus === 1 ? "danger" : "success"
                        } px-3 font-weight-bold d-flex align-items-center justify-content-center`}
                    >
                        {userStatus === 1 ? (
                            <>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    height="1em"
                                    viewBox="0 0 512 512"
                                    className="mr-1"
                                >
                                    <path
                                        d="M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
                                        fill="currentColor"
                                    />
                                </svg>
                                Deactivate Profile
                            </>
                        ) : (
                            <>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    height="1em"
                                    viewBox="0 0 512 512"
                                    className="mr-1"
                                >
                                    <path
                                        d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"
                                        fill="currentColor"
                                    />
                                </svg>
                                Activate Profile
                            </>
                        )}
                    </button>
                </div>
            </div>
        </>
    );
};

export default ProfileActivation;
